import React from "react";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../hooks/useStore";
import {SelectField, FilterLabel} from "./FilterComponentStyles";
import {useObserver} from "mobx-react-lite";
import {VFlex} from "components/_defaultComponents/Flex/VFlex";

const ShiftScoreCourierStatusFilter = ({
    showAllOption = false,
    allKey = "all",
    hideTitle = false,
    selectMarginBottom = "20px",
    optionFilter = () => {
        return true;
    },
    ...props
}) => {
    const {t} = useTranslation();
    const stores = useStore();

    return useObserver(() => (
        <VFlex vertical gap={8} align="stretch">
            {!hideTitle && <FilterLabel>{"Kurye Durumu"}</FilterLabel>}

            <VFlex wrap align="stretch">
                <SelectField
                    allowClear
                    showSearch
                    mb={selectMarginBottom}
                    data-testid="courierStatusSelect"
                    {...props}
                >
                    {showAllOption && (
                        <SelectField.Option value={allKey} data-testid="courierStatusSelect_option">
                            {t("filters.all", {ns: "common"})}
                        </SelectField.Option>
                    )}

                    <SelectField.Option
                        key={"active"}
                        value={"active"}
                        data-testid="courierStatusSelect_option"
                    >
                        Aktif
                    </SelectField.Option>
                    <SelectField.Option
                        key={"inactive"}
                        value={"inactive"}
                        data-testid="courierStatusSelect_option"
                    >
                        Meşgul
                    </SelectField.Option>
                </SelectField>
            </VFlex>
        </VFlex>
    ));
};

export default ShiftScoreCourierStatusFilter;
